import {Container, Divider, Form, Tab} from "semantic-ui-react";
import {SurveyFormModel} from "../model/SurveyFormModel";
import SurveyFormEditor from "./SurveyFormEditor";
import React, {useEffect, useState} from "react";
import {AppListPageDialogContext, AppListPageDialogContextState} from "../../common/AppListPage";
import {toInteger} from "lodash";

interface Props {
    context: AppListPageDialogContext<SurveyFormModel>
}

const SurveyFormDetails = (props: Props) => {
    const [name, setName] = useState<string>(props.context.model?.name ?? "");
    const [comment, setComment] = useState<string | undefined>(props.context.model?.comment);
    const [greetingText, setGreetingText] = useState<string | undefined>(props.context.model?.greetingText);
    const [finishText, setFinishText] = useState<string | undefined>(props.context.model?.finishText);

    const readOnly = props.context.state == AppListPageDialogContextState.view;
    const [nameError, setNameError] = useState<string>();
    const [tabActiveIndex, setTabActiveIndex] = useState<number>(0);

    useEffect(() => {
        Object.assign(props.context.model, {
            name: name,
            comment: comment,
            greetingText: greetingText,
            finishText: finishText
        });
    }, [name, comment, greetingText, finishText]);

    const panes = [
        {
            menuItem: 'Общая информация', render: () => <Tab.Pane style={{minHeight: 500}}>

                <Container fluid><Form>
                    <Form.Input
                        label={'Наименование анкеты'}
                        value={name}
                        error={nameError}
                        onChange={!readOnly ? (e, data) => {
                            setName(data.value);
                        } : undefined}/>
                    <Form.TextArea label={"Приветственное сообщение"} value={greetingText}
                                   readOnly={readOnly}
                                   maxLength={300}
                                   onChange={(e, v) => setGreetingText(v.value?.toString())}/>
                    <Form.TextArea label={"Заключительное сообщение"} value={finishText}
                                   readOnly={readOnly}
                                   maxLength={300}
                                   onChange={(e, v) => setFinishText(v.value?.toString())}/>
                    <Divider/>
                    <Form.TextArea label={"Примечания"} value={comment}
                                   readOnly={readOnly}
                                   maxLength={1000}
                                   onChange={(e, v) => setComment(v.value?.toString())}/>
                </Form>
                </Container>
            </Tab.Pane>
        },
        {
            menuItem: 'Вопросы', render: () => <Tab.Pane style={{minHeight: 500}}>
                <div style={{height: "600px"}}>
                    <SurveyFormEditor model={props.context.model} readonly={readOnly}/>
                </div>
            </Tab.Pane>
        }];

    async function validate(): Promise<boolean> {
        let result = true;
        setNameError(undefined);
        if ((name?.length ?? 0) == 0) {
            setNameError("Наименование должно быть заполнено");
            result = false;
        }
        if ((props.context.model?.questions?.length ?? 0) == 0) {
            setTabActiveIndex(1);
            result = false;
            alert('Не заданы вопросы формы опроса!');
        }
        return result;
    }

    props.context.validateCallback = validate;


    return <Container fluid>
        <Tab panes={panes} activeIndex={tabActiveIndex}
             onTabChange={(event, data) =>
                 setTabActiveIndex(toInteger(data.activeIndex))}/>
    </Container>;
}

export default SurveyFormDetails;